import { useEffect } from 'react';

const SITE_NAME  = 'halfprice.ca';
const SITE_URL   = 'https://halfprice.ca';
const DEFAULT_DESC = 'Up to 50% off at Winnipeg\'s best local restaurants. Claim deals instantly — no account needed. Zero commission to restaurants.';
const DEFAULT_IMG  = `${SITE_URL}/og-image.jpg`;

function setMeta(attr, name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) { el = document.createElement('meta'); el.setAttribute(attr, name); document.head.appendChild(el); }
  el.setAttribute('content', content);
}

function setLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) { el = document.createElement('link'); el.setAttribute('rel', rel); document.head.appendChild(el); }
  el.setAttribute('href', href);
}

export default function SEO({
  title,
  description,
  image,
  url,
  type = 'website',
  noindex = false,
}) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Local flavour, half the price | Winnipeg`;
    const desc      = description || DEFAULT_DESC;
    const img       = image || DEFAULT_IMG;
    const canonical = url ? `${SITE_URL}${url}` : window.location.href;

    // Page title
    document.title = fullTitle;

    // Standard meta
    setMeta('name', 'description', desc);
    setMeta('name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow');

    // Open Graph
    setMeta('property', 'og:title',       fullTitle);
    setMeta('property', 'og:description', desc);
    setMeta('property', 'og:type',        type);
    setMeta('property', 'og:url',         canonical);
    setMeta('property', 'og:image',       img);
    setMeta('property', 'og:image:width',  '1200');
    setMeta('property', 'og:image:height', '630');
    setMeta('property', 'og:site_name',   SITE_NAME);
    setMeta('property', 'og:locale',      'en_CA');

    // Twitter Card
    setMeta('name', 'twitter:card',        'summary_large_image');
    setMeta('name', 'twitter:title',       fullTitle);
    setMeta('name', 'twitter:description', desc);
    setMeta('name', 'twitter:image',       img);
    setMeta('name', 'twitter:site',        '@halfpriceca');

    // Canonical URL
    setLink('canonical', canonical);

    return () => {
      // Reset to default on unmount
      document.title = `${SITE_NAME} — Local flavour, half the price | Winnipeg`;
    };
  }, [title, description, image, url, type, noindex]);

  return null;
}
